import script from "./DataDownload.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataDownload.vue?vue&type=script&setup=true&lang=ts"

import "./DataDownload.vue?vue&type=style&index=0&id=3a992e0a&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a992e0a"]])

export default __exports__